import { Typography, Container } from "@mui/material";

import { Link } from "react-router-dom";
import { collection, getDocs, query, where, doc } from "firebase/firestore";

import { db } from "../firebase.config";
import { toast } from "react-toastify";

import React from "react";
import { useState, useEffect } from "react";
import { getAuth } from "firebase/auth";
import Spinner from "../components/Spinner.jsx";

function MyTierLists(props) {
  const auth = getAuth();
  const { appState, setAppState } = props;
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTierLists = async () => {
      try {
        // Get Reference
        const tierListRef = collection(db, "tierLists");
        // Create a query
        // const queryString = genreId;
        // const genreRef = doc(db, "formGenres", queryString);
        const userId = auth.currentUser?.uid;
        const userRef = doc(db, "users", userId);
        const q = query(
          tierListRef,
          where("author", "==", userRef),
          where("draft", "==", false)
        );

        // Execute query
        const querySnap = await getDocs(q);

        const tierListObject = {
          tierLists: [],
        };

        querySnap.forEach((doc) => {
          tierListObject.tierLists.push({
            id: doc.id,
            data: doc.data(),
          });
          return;
        });
        setAppState((prevState) => ({
          ...prevState,
          drafts: tierListObject.tierLists,
        }));
        setLoading(false);
        return tierListObject;
      } catch (error) {
        setLoading(false);
        console.log(error);
        toast.error("Could not fetch listings");
      }
    };
    if (auth.currentUser?.uid) {
      fetchTierLists();
    }
  }, [setAppState, auth.currentUser]);

  return (
    <Container>
      <Typography variant="h1" component="h1">
        Your Tier Lists:
      </Typography>
      {loading ? (
        <Spinner />
      ) : (
        <>
          {appState.drafts?.map((draft) => (
            <div key={draft.id}>
              {draft.data.titleName}-{" "}
              <Link to={"/tierlist/" + draft.id}>{draft.id}</Link>
            </div>
          ))}
        </>
      )}
    </Container>
  );
}

export default MyTierLists;
